import { AuthorizationActions } from '../userAccount/actionNames'

export default function(
  store: INotificationsService = {
    accessToken: '',
    lang: '',
    modifyDate: '',
  },
  action,
) {
  switch (action.type) {
    case 'Set notification service state':
      return {
        accessToken: action.accessToken,
        lang: action.lang,
        modifyDate: action.modifyDate,
      }
    case AuthorizationActions.FlushState:
      return {
        accessToken: '',
        lang: '',
        modifyDate: '',
      }
  }

  return store
}

export interface INotificationsService {
  accessToken: string
  modifyDate: string
  lang: string
}
